import { allLanguageBackendMessages } from './i18n/backendMessages';
import { Language } from './types/dto-app';
import type { CustomLabel } from './types/model-app';

export const getEntityLabels = (label?: string): CustomLabel[] => [
  ...Object.keys(allLanguageBackendMessages).map((lang) => ({
    language: lang as Language,
    label: label ?? '',
  })),
];

/** One label per supported language, in the order English, French, Dutch, German. */
export const makeLabels = (en: string, fr: string, nl: string, de: string): CustomLabel[] => [
  { language: Language.EN, label: en },
  { language: Language.FR, label: fr },
  { language: Language.NL, label: nl },
  { language: Language.DE, label: de },
];

const LABEL_LANGUAGES: Language[] = [Language.EN, Language.FR, Language.NL, Language.DE];

type BackendMessages = (typeof allLanguageBackendMessages)[keyof typeof allLanguageBackendMessages];

/** One label per supported language, read from the backend translations, in the order of `makeLabels`. */
export const makeTranslatedLabels = (getLabel: (messages: BackendMessages) => string): CustomLabel[] =>
  LABEL_LANGUAGES.map((language) => ({ language, label: getLabel(allLanguageBackendMessages[language]) }));
